import OfferEvent from '@core/models/offer/OfferEvent';

export const getAnalyticsEventId = (eventId: OfferEvent['id']): string => {
    return `ax:match:${eventId}`;
};
